import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'; // أضف هذا الـ import للترجمة
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const DeleteConfirmationModal = ({ 
  isOpen, 
  onClose, 
  category, 
  categories, 
  onConfirm 
}) => {
  const { t } = useTranslation(); // استخدم useTranslation للترجمة
  const [reassignCategoryId, setReassignCategoryId] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const handleConfirm = async () => {
    setIsProcessing(true);
    
    try {
      await onConfirm(category.id, reassignCategoryId);
      onClose();
      setReassignCategoryId('');
    } catch (error) {
      console.error('Delete failed:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleClose = () => {
    setReassignCategoryId('');
    onClose();
  };

  // استخدم products_count بدلاً من productCount للتوافق مع البيانات العربية
  const hasProducts = category?.products_count > 0;
  const hasSubcategories = category?.children && category.children.length > 0;

  // خيارات إعادة التعيين: استخدم الاسم العربي وعدد المنتجات
  const reassignOptions = categories
    .filter(cat => cat.id !== category?.id)
    .map(cat => ({
      value: cat.id,
      label: cat.translations?.ar?.name || cat.name || 'غير محدد', // استخدم الاسم العربي
      description: `${cat.products_count || 0} ${t('products')}` // ترجمة "products"
    }));

  if (!isOpen || !category) return null;

  // اسم الفئة بالعربية
  const categoryName = category.translations?.ar?.name || category.name || 'غير محدد';
  // وصف الفئة إذا كان موجوداً (افترض أنه translations.ar.description، أو أزل إذا غير موجود)
  const categoryDescription = category.translations?.ar?.description || '';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-elevation-3 w-full max-w-md mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-md bg-error/10 flex items-center justify-center">
              <Icon name="AlertTriangle" size={20} className="text-error" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">{t('deleteCategoryTitle')}</h2>
              <p className="text-sm text-muted-foreground">{t('deleteActionIrreversible')}</p>
            </div>
          </div>
          
          <Button
            variant="ghost"
            size="icon"
            onClick={handleClose}
            disabled={isProcessing}
          >
            <Icon name="X" size={20} />
          </Button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div className="bg-surface rounded-lg p-4">
            <div className="flex items-center space-x-3 mb-3">
              <div className="w-8 h-8 rounded-md bg-surface flex items-center justify-center">
                <Icon name={category.icon || 'Folder'} size={16} className="text-primary" />
              </div>
              <div>
                <h3 className="font-medium text-foreground">{categoryName}</h3>
                {categoryDescription && (
                  <p className="text-sm text-muted-foreground">{categoryDescription}</p>
                )}
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <span className="text-muted-foreground">{t('products')}:</span>
                <span className="ml-2 font-medium text-foreground">{category.products_count || 0}</span>
              </div>
              <div>
                <span className="text-muted-foreground">{t('subcategories')}:</span>
                <span className="ml-2 font-medium text-foreground">{category.sub_categories_count }</span>
              </div>
            </div>
          </div>

         

          {!hasProducts && !hasSubcategories && (
            <div className="bg-error/10 border border-error/20 rounded-md p-4">
              <div className="flex items-start space-x-3">
                <Icon name="Trash2" size={20} className="text-error flex-shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-medium text-error mb-1">{t('confirmDeletion')}</h4>
                  <p className="text-sm text-error/80">
                    {t('confirmDeleteMessage', { categoryName })}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border gap-2">
          <Button
            variant="outline"
            onClick={handleClose}
            disabled={isProcessing}
          >
            {t('cancel')}
          </Button>
          
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isProcessing}
            loading={isProcessing}
            iconName="Trash2"
            iconPosition="left"
          >
            {t('deleteCategory')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
